/**
 * @file 常量
 * @author alfielv
 */
export var PREFIX_CLS = 'ptp';